export class Commons {

    static markAsInvalid(key) {
        let item = document.querySelector('#item__' + key);
       
        if (item) {
            item.classList.remove('ng-valid');
            item.classList.add('ng-invalid');
            item.classList.add('ng-dirty');
            item.classList.add('ng-touched');
        }
    }

    static markAsValid(key) {
        let item = document.querySelector('#item__' + key);

        if (item) {
            item.classList.add('ng-valid');
            item.classList.remove('ng-invalid');
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/commons.ts